import React, { useState, useEffect, useRef } from 'react';
import Cards from '../cards/cards';
import styles from "./publication.module.scss";

const ProjectCard = ({ project }) => {
    return (
        <div className={styles.projects_card}>
            <h3>{project.heading}</h3>
            <p>{project.description}</p>
            <div className={styles.buttons}>
                {project.link && (
                    <a href={project.link} target="_blank" rel="noopener noreferrer">
                        View Paper
                    </a>
                )}
            </div>
        </div>
    );
};

const Publication = () => {
    const [typedText, setTypedText] = useState('');
    const fullText = 'Publications.';
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    let index = 0;
                    const typingInterval = setInterval(() => {
                        if (index < fullText.length) {
                            setTypedText(fullText.slice(0, index + 1));
                            index++;
                        } else {
                            clearInterval(typingInterval);
                        }
                    }, 150);
                }
            },
            { threshold: 0.5 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    const ProjectsData = [
        {
            heading: "Tele medicine a web-portal for patients to have an online consultation with doctors",
            description: "This project was published in the International Journal of Advances in Engineering and Management (IJAEM), showcasing the advancements in telemedicine and its impact on healthcare accessibility.",
            technologies: [],
            link: "https://ijaem.net/issue_dcp/Tele%20medicine%20a%20web%20portal%20for%20patients%20to%20have%20an%20online%20consultation%20with%20doctors..pdf",
        },
        {
            heading: "Object Recognition Tool for Visually Impaired",
            description: "This project was published in the International Journal of Scientific Research and Development (IJSRD), highlighting the development of an object recognition tool for visually impaired individuals.",
            technologies: [],
            link: "https://www.ijsrd.com/articles/IJSRDV7I110450.pdf",
        },
        {
            heading: "Introduction to Distributed Computing System",
            description: "This project was published in the International Journal of Scientific Research and Development (IJSRD), providing an overview of distributed computing systems and their applications.",
            technologies: [],
            link: "https://www.ijsrd.com/articles/IJSRDV7I50399.pdf",
        }
    ];

    return (
        <section id="publication" ref={sectionRef} className={styles.projects}>
            <div className={`xl:mt-12 flex xl:flex-row flex-col-reverse gap-10 justify-left overflow-hidden`}>
                <div className={`flex-[0.6] p-10 md:p-16 lg:p-20 rounded-2xl`}>
                    <h2 className={`main_color ${styles.typing}`}>{typedText}</h2>
                    <div className={`text-lg`}>
                        Below are some of the publications I have contributed to, reflecting the skills and knowledge I’ve developed through my academic journey and professional experiences. 
                </div>
                </div>
            </div>
            <div className={`p-10 md:p-16 lg:p-20 md:pt-0 lg:pt-0 pt-0 ` + styles.projects_container}>
                {ProjectsData.map((project, index) => {
                    return (
                        <Cards data={project} index={index} key={index} />
                    );
                })}
            </div>
        </section>
    );
};

export default Publication;
